import React from 'react';
import { rem } from 'polished';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import Label from './parts/Label';
import { EchIconFieldError } from '../../../primitives/IconSVG';
import FieldError from './parts/FieldError';
import i18n from '../digitID-i18n';

const StyledInput = styled.div(
  ({ error }: { error?: boolean }) => css`
    position: relative;

    input {
      white-space: nowrap;
      text-overflow: ellipsis;
      min-height: ${rem(58)};
      padding: ${rem(11)} ${rem(16)};

      ${error &&
      css`
        padding-right: ${rem(36)};
      `}
    }
  `,
);

const StyledErrorIcon = styled(EchIconFieldError)`
  position: absolute;
  top: 50%;
  right: ${rem(12)};
  transform: translateY(-50%);
  width: ${rem(16)};
  height: ${rem(16)};
`;

const Input = ({
  id,
  label,
  locale,
  value,
  onChange,
  onBlur,
  onFocus,
  error,
  placeholder,
  isRequired,
  isDisabled,
  type,
  errorRenderer,
  tooltip,
}: any) => {
  return (
    <div>
      {label && (
        <Label id={id} tooltip={tooltip} isRequired={isRequired}>
          {label}
        </Label>
      )}
      <StyledInput error={error}>
        <input
          name={id}
          id={id}
          value={value || ''}
          placeholder={placeholder}
          type={type || 'text'}
          disabled={!!isDisabled}
          aria-required={!!isRequired}
          data-error={!!error}
          onChange={(e) => {
            if (typeof onChange === 'function') onChange(e.target.value);
          }}
          onFocus={() => {
            if (typeof onFocus === 'function') onFocus();
          }}
          onBlur={(e) => {
            if (typeof onBlur === 'function') onBlur();
            if (typeof onChange === 'function') onChange(e.target.value.trim());
          }}
        />
        {error && <StyledErrorIcon />}
      </StyledInput>
      {error ? (
        errorRenderer ? (
          errorRenderer(error)
        ) : (
          <FieldError text={i18n.requiredField[locale]} />
        )
      ) : null}
    </div>
  );
};

export const isValid = (value: any, config: any) =>
  config.isRequired && !value ? false : true;

export default Input;
